import { render, staticRenderFns } from "./SlideBanner.vue?vue&type=template&id=360f90ce&"
import script from "./SlideBanner.vue?vue&type=script&lang=js&"
export * from "./SlideBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports